export const environment = {
    api_url : 'https://api.fanbudget.com',
    app_url: 'https://fanbudget.com',
    pdf_url: 'https://api.fanbudget.com',
};
